// Hotel database — top hotels across Cancún and Riviera Maya grouped by zone.
// Prices are ONE-WAY airport-to-hotel per vehicle type in USD.
// Round-trip is auto-calculated on the frontend (~1.85x one-way).

export const zonePricing = {
  "cancun-downtown": { suv: 65, van: 95, luxury: 160, label: { en: "Cancún Downtown", es: "Cancún Centro" } },
  "cancun-hz-north": { suv: 75, van: 110, luxury: 180, label: { en: "Cancún Hotel Zone (km 1–14)", es: "Zona Hotelera Norte (km 1–14)" } },
  "cancun-hz-south": { suv: 85, van: 125, luxury: 200, label: { en: "Cancún Hotel Zone (km 14–25)", es: "Zona Hotelera Sur (km 14–25)" } },
  "playa-mujeres": { suv: 85, van: 125, luxury: 200, label: { en: "Playa Mujeres", es: "Playa Mujeres" } },
  "puerto-morelos": { suv: 85, van: 125, luxury: 200, label: { en: "Puerto Morelos", es: "Puerto Morelos" } },
  "playa-del-carmen": { suv: 110, van: 150, luxury: 240, label: { en: "Playa del Carmen", es: "Playa del Carmen" } },
  "playacar": { suv: 115, van: 155, luxury: 245, label: { en: "Playacar", es: "Playacar" } },
  "puerto-aventuras": { suv: 130, van: 175, luxury: 275, label: { en: "Puerto Aventuras", es: "Puerto Aventuras" } },
  "akumal": { suv: 135, van: 180, luxury: 280, label: { en: "Akumal", es: "Akumal" } },
  "tulum-hz": { suv: 170, van: 225, luxury: 340, label: { en: "Tulum Hotel Zone", es: "Zona Hotelera Tulum" } },
  "tulum-town": { suv: 155, van: 200, luxury: 320, label: { en: "Tulum Downtown / Aldea Zamá", es: "Tulum Centro / Aldea Zamá" } },
  "isla-mujeres": { suv: 90, van: 130, luxury: 210, label: { en: "Isla Mujeres (via ferry)", es: "Isla Mujeres (vía ferry)" } },
};

export const hotels = [
  // ========= Cancún Downtown =========
  { id: "krystal-urban", name: "Krystal Urban Cancún", zone: "cancun-downtown", stars: 4 },
  { id: "hotel-antillano", name: "Hotel Antillano", zone: "cancun-downtown", stars: 3 },
  { id: "adhara-hacienda", name: "Adhara Hacienda Cancún", zone: "cancun-downtown", stars: 4 },
  { id: "courtyard-marriott-cancun", name: "Courtyard by Marriott Cancún Airport", zone: "cancun-downtown", stars: 4 },

  // ========= Cancún Hotel Zone North (km 1-14) =========
  { id: "hard-rock-cancun", name: "Hard Rock Hotel Cancún", zone: "cancun-hz-north", stars: 5 },
  { id: "riu-cancun", name: "Riu Cancún", zone: "cancun-hz-north", stars: 5 },
  { id: "riu-caribe", name: "Riu Caribe", zone: "cancun-hz-north", stars: 5 },
  { id: "riu-palace-las-americas", name: "Riu Palace Las Américas", zone: "cancun-hz-north", stars: 5 },
  { id: "riu-palace-peninsula", name: "Riu Palace Península", zone: "cancun-hz-north", stars: 5 },
  { id: "krystal-cancun", name: "Krystal Cancún", zone: "cancun-hz-north", stars: 4 },
  { id: "krystal-grand-cancun", name: "Krystal Grand Cancún Resort", zone: "cancun-hz-north", stars: 5 },
  { id: "beach-palace", name: "Beach Palace", zone: "cancun-hz-north", stars: 5 },
  { id: "sun-palace", name: "Sun Palace", zone: "cancun-hz-north", stars: 5 },
  { id: "hyatt-ziva-cancun", name: "Hyatt Ziva Cancún", zone: "cancun-hz-north", stars: 5 },
  { id: "hyatt-zilara-cancun", name: "Hyatt Zilara Cancún", zone: "cancun-hz-north", stars: 5 },
  { id: "marriott-cancun", name: "Marriott Cancún Resort", zone: "cancun-hz-north", stars: 5 },
  { id: "jw-marriott-cancun", name: "JW Marriott Cancún Resort & Spa", zone: "cancun-hz-north", stars: 5 },
  { id: "fiesta-americana-condesa", name: "Fiesta Americana Condesa Cancún", zone: "cancun-hz-north", stars: 5 },
  { id: "the-westin-lagunamar", name: "The Westin Lagunamar Ocean Resort", zone: "cancun-hz-north", stars: 5 },
  { id: "the-westin-resort-cancun", name: "The Westin Resort & Spa Cancún", zone: "cancun-hz-north", stars: 5 },
  { id: "grand-fiesta-coral-beach", name: "Grand Fiesta Americana Coral Beach", zone: "cancun-hz-north", stars: 5 },
  { id: "aloft-cancun", name: "Aloft Cancún", zone: "cancun-hz-north", stars: 4 },
  { id: "wyndham-alltra-cancun", name: "Wyndham Alltra Cancún", zone: "cancun-hz-north", stars: 4 },
  { id: "presidente-intercontinental", name: "InterContinental Presidente Cancún Resort", zone: "cancun-hz-north", stars: 5 },
  { id: "royal-solaris", name: "Royal Solaris Cancún", zone: "cancun-hz-north", stars: 5 },
  { id: "smart-cancun", name: "Smart Cancún by Oasis", zone: "cancun-hz-north", stars: 4 },
  { id: "oasis-palm", name: "Oasis Palm", zone: "cancun-hz-north", stars: 4 },
  { id: "grand-oasis-cancun", name: "Grand Oasis Cancún", zone: "cancun-hz-north", stars: 5 },
  { id: "grand-oasis-palm", name: "Grand Oasis Palm", zone: "cancun-hz-north", stars: 5 },

  // ========= Cancún Hotel Zone South (km 14-25) =========
  { id: "moon-palace-cancun", name: "Moon Palace Cancún", zone: "cancun-hz-south", stars: 5 },
  { id: "hard-rock-riviera-cancun", name: "Hard Rock Hotel Riviera Maya (Heaven)", zone: "cancun-hz-south", stars: 5 },
  { id: "iberostar-cancun", name: "Iberostar Selection Cancún", zone: "cancun-hz-south", stars: 5 },
  { id: "iberostar-cancun-star-prestige", name: "Iberostar Cancún Star Prestige", zone: "cancun-hz-south", stars: 5 },
  { id: "royalton-riviera-cancun", name: "Royalton Riviera Cancún", zone: "cancun-hz-south", stars: 5 },
  { id: "royalton-splash-riviera-cancun", name: "Royalton Splash Riviera Cancún", zone: "cancun-hz-south", stars: 5 },
  { id: "sandos-cancun", name: "Sandos Cancún Lifestyle Resort", zone: "cancun-hz-south", stars: 5 },
  { id: "great-parnassus", name: "Great Parnassus Resort & Spa", zone: "cancun-hz-south", stars: 5 },
  { id: "grand-park-royal-cancun", name: "Grand Park Royal Cancún", zone: "cancun-hz-south", stars: 5 },
  { id: "temptation-cancun", name: "Temptation Cancún Resort (Adults Only)", zone: "cancun-hz-south", stars: 5 },
  { id: "cancun-bay", name: "Cancún Bay Resort", zone: "cancun-hz-south", stars: 4 },
  { id: "occidental-tucancun", name: "Occidental Tucancún", zone: "cancun-hz-south", stars: 5 },
  { id: "paradisus-cancun", name: "Paradisus Cancún", zone: "cancun-hz-south", stars: 5 },
  { id: "the-ritz-carlton-cancun", name: "The Ritz-Carlton Cancún", zone: "cancun-hz-south", stars: 5 },
  { id: "live-aqua-beach", name: "Live Aqua Beach Resort Cancún", zone: "cancun-hz-south", stars: 5 },
  { id: "secrets-the-vine", name: "Secrets The Vine Cancún", zone: "cancun-hz-south", stars: 5 },
  { id: "hyatt-zilara-riviera", name: "Hyatt Zilara Riviera Maya (Cancún South)", zone: "cancun-hz-south", stars: 5 },

  // ========= Playa Mujeres =========
  { id: "excellence-playa-mujeres", name: "Excellence Playa Mujeres", zone: "playa-mujeres", stars: 5 },
  { id: "beloved-playa-mujeres", name: "Beloved Playa Mujeres", zone: "playa-mujeres", stars: 5 },
  { id: "finest-playa-mujeres", name: "Finest Playa Mujeres by The Excellence Collection", zone: "playa-mujeres", stars: 5 },
  { id: "atelier-playa-mujeres", name: "Atelier Playa Mujeres", zone: "playa-mujeres", stars: 5 },
  { id: "trs-coral", name: "TRS Coral Hotel", zone: "playa-mujeres", stars: 5 },
  { id: "dreams-playa-mujeres", name: "Dreams Playa Mujeres Golf & Spa", zone: "playa-mujeres", stars: 5 },

  // ========= Puerto Morelos =========
  { id: "now-jade", name: "Now Jade Riviera Cancún", zone: "puerto-morelos", stars: 5 },
  { id: "dreams-jade", name: "Dreams Jade Resort & Spa", zone: "puerto-morelos", stars: 5 },
  { id: "hyatt-ziva-riviera", name: "Hyatt Ziva Riviera Cancún", zone: "puerto-morelos", stars: 5 },
  { id: "secrets-silversands", name: "Secrets Silversands Riviera Cancún", zone: "puerto-morelos", stars: 5 },
  { id: "azul-beach", name: "Azul Beach Resort Riviera Cancún", zone: "puerto-morelos", stars: 5 },
  { id: "grand-residences-riviera", name: "Grand Residences Riviera Cancún", zone: "puerto-morelos", stars: 5 },

  // ========= Playa del Carmen =========
  { id: "hyatt-ziva-riviera-maya", name: "Hyatt Ziva Riviera Maya", zone: "playa-del-carmen", stars: 5 },
  { id: "grand-hyatt-playa", name: "Grand Hyatt Playa del Carmen Resort", zone: "playa-del-carmen", stars: 5 },
  { id: "thompson-playa", name: "Thompson Playa del Carmen", zone: "playa-del-carmen", stars: 5 },
  { id: "hilton-playa-del-carmen", name: "Hilton Playa del Carmen (Adults Only)", zone: "playa-del-carmen", stars: 5 },
  { id: "the-fives-beach", name: "The Fives Beach Hotel & Residences", zone: "playa-del-carmen", stars: 5 },
  { id: "the-fives-downtown", name: "The Fives Downtown Hotel & Residences", zone: "playa-del-carmen", stars: 4 },
  { id: "sandos-caracol", name: "Sandos Caracol Eco Resort", zone: "playa-del-carmen", stars: 5 },
  { id: "sandos-playacar", name: "Sandos Playacar Beach Resort", zone: "playacar", stars: 5 },
  { id: "riu-playacar", name: "Riu Playacar", zone: "playacar", stars: 5 },
  { id: "riu-palace-riviera", name: "Riu Palace Riviera Maya", zone: "playacar", stars: 5 },
  { id: "riu-yucatan", name: "Riu Yucatán", zone: "playacar", stars: 4 },
  { id: "iberostar-playacar", name: "Iberostar Selection Playa Mita (Playacar)", zone: "playacar", stars: 5 },
  { id: "mahekal", name: "Mahekal Beach Resort", zone: "playa-del-carmen", stars: 4 },
  { id: "playa-palms", name: "Playa Palms Beach Hotel", zone: "playa-del-carmen", stars: 4 },
  { id: "royal-hideaway", name: "Royal Hideaway Playacar (Adults Only)", zone: "playacar", stars: 5 },
  { id: "reef-playacar", name: "Reef Playacar", zone: "playacar", stars: 4 },
  { id: "occidental-playacar", name: "Occidental at Xcaret Destination", zone: "playacar", stars: 5 },
  { id: "hotel-xcaret", name: "Hotel Xcaret México", zone: "playa-del-carmen", stars: 5 },
  { id: "hotel-xcaret-arte", name: "Hotel Xcaret Arte (Adults Only)", zone: "playa-del-carmen", stars: 5 },
  { id: "unico-2087", name: "UNICO 20°87° Hotel Riviera Maya", zone: "playa-del-carmen", stars: 5 },

  // ========= Puerto Aventuras =========
  { id: "catalonia-riviera", name: "Catalonia Riviera Maya & Yucatán Beach", zone: "puerto-aventuras", stars: 5 },
  { id: "omni-puerto-aventuras", name: "Omni Puerto Aventuras Beach Resort", zone: "puerto-aventuras", stars: 5 },
  { id: "dreams-puerto-aventuras", name: "Dreams Puerto Aventuras Resort", zone: "puerto-aventuras", stars: 5 },
  { id: "hard-rock-riviera-maya", name: "Hard Rock Hotel Riviera Maya (Hacienda)", zone: "puerto-aventuras", stars: 5 },

  // ========= Akumal =========
  { id: "grand-sirenis-riviera", name: "Grand Sirenis Riviera Maya Resort", zone: "akumal", stars: 5 },
  { id: "bahia-principe-tulum", name: "Bahia Principe Grand Tulum", zone: "akumal", stars: 5 },
  { id: "bahia-principe-akumal", name: "Bahia Principe Grand Coba", zone: "akumal", stars: 5 },
  { id: "iberostar-paraiso", name: "Iberostar Selection Paraíso Maya", zone: "akumal", stars: 5 },
  { id: "secrets-akumal", name: "Secrets Akumal Riviera Maya", zone: "akumal", stars: 5 },
  { id: "unico-akumal", name: "Grand Palladium White Sand", zone: "akumal", stars: 5 },
  { id: "occidental-xcaret-akumal", name: "Occidental at Xcaret (Akumal side)", zone: "akumal", stars: 5 },
  { id: "sunscape-akumal", name: "Sunscape Akumal Beach Resort", zone: "akumal", stars: 5 },

  // ========= Tulum Hotel Zone =========
  { id: "azulik", name: "Azulik (Adults Only)", zone: "tulum-hz", stars: 5 },
  { id: "papaya-playa", name: "Papaya Playa Project", zone: "tulum-hz", stars: 4 },
  { id: "nomade-tulum", name: "Nômade Tulum", zone: "tulum-hz", stars: 5 },
  { id: "be-tulum", name: "Be Tulum Beach & Spa Resort", zone: "tulum-hz", stars: 5 },
  { id: "casa-malca", name: "Casa Malca", zone: "tulum-hz", stars: 5 },
  { id: "la-zebra", name: "La Zebra Tulum", zone: "tulum-hz", stars: 4 },
  { id: "ahau-tulum", name: "Ahau Tulum", zone: "tulum-hz", stars: 4 },
  { id: "diamante-k", name: "Diamante K", zone: "tulum-hz", stars: 3 },
  { id: "mi-amor", name: "Mi Amor by Colibrí Boutique Hotels", zone: "tulum-hz", stars: 5 },
  { id: "amansala", name: "Amansala Resort", zone: "tulum-hz", stars: 4 },
  { id: "the-beach-tulum", name: "The Beach Tulum", zone: "tulum-hz", stars: 5 },

  // ========= Tulum Downtown / Aldea Zamá =========
  { id: "kimpton-aluna", name: "Kimpton Aluna Tulum", zone: "tulum-town", stars: 5 },
  { id: "conrad-tulum", name: "Conrad Tulum Riviera Maya", zone: "tulum-town", stars: 5 },
  { id: "la-valise-tulum", name: "La Valise Tulum", zone: "tulum-town", stars: 5 },
  { id: "our-habitas", name: "Our Habitas Tulum", zone: "tulum-town", stars: 5 },
  { id: "hotel-bardo", name: "Hotel Bardo Tulum", zone: "tulum-town", stars: 5 },
  { id: "aloft-tulum", name: "Aloft Tulum", zone: "tulum-town", stars: 4 },
  { id: "the-explorean-kohunlich", name: "The Explorean Kohunlich (by Fiesta Americana)", zone: "tulum-town", stars: 5 },

  // ========= Isla Mujeres =========
  { id: "isla-mujeres-palace", name: "Isla Mujeres Palace (Adults Only)", zone: "isla-mujeres", stars: 5 },
  { id: "mia-reef-isla", name: "Mia Reef Isla Mujeres", zone: "isla-mujeres", stars: 5 },
  { id: "privilege-aluxes", name: "Privilege Aluxes Isla Mujeres", zone: "isla-mujeres", stars: 5 },
  { id: "hotel-secreto", name: "Hotel Secreto", zone: "isla-mujeres", stars: 4 },
  { id: "almare-isla", name: "Almare, a Luxury Collection Adult All-Inclusive", zone: "isla-mujeres", stars: 5 },
];

export const hotelLabels = {
  en: {
    eyebrow: "HOTEL FINDER",
    title: "Find your hotel. Get an instant transfer quote.",
    subtitle: "Every property in Cancún and the Riviera Maya. Real prices in USD — no waiting for an email.",
    searchPh: "Search by hotel name or zone…",
    filterAll: "All zones",
    stars: "stars",
    fromCUN: "From CUN Airport",
    perVehicle: "per vehicle · one-way",
    suv: "Executive SUV",
    van: "Sprinter Van",
    luxury: "Luxury Sedan",
    seeQuote: "See quote →",
    empty: "No hotels match your search.",
    backHome: "Home",
    quoteTitle: "Your quote",
    service: "Service",
    oneWay: "One-way",
    roundTrip: "Round-trip",
    vehicle: "Vehicle",
    total: "Total",
    checkout: "Checkout & reserve",
    close: "Close",
    quoteSaved: "Quote generated. Complete your booking below.",
  },
  es: {
    eyebrow: "BÚSQUEDA DE HOTELES",
    title: "Encuentra tu hotel. Recibe la cotización al instante.",
    subtitle: "Cada propiedad en Cancún y la Riviera Maya. Precios reales en USD — sin esperar un correo.",
    searchPh: "Buscar por nombre o zona…",
    filterAll: "Todas las zonas",
    stars: "estrellas",
    fromCUN: "Desde el Aeropuerto CUN",
    perVehicle: "por vehículo · sencillo",
    suv: "SUV Ejecutiva",
    van: "Sprinter Van",
    luxury: "Sedán de Lujo",
    seeQuote: "Ver cotización →",
    empty: "Ningún hotel coincide con tu búsqueda.",
    backHome: "Inicio",
    quoteTitle: "Tu cotización",
    service: "Servicio",
    oneWay: "Sencillo",
    roundTrip: "Redondo",
    vehicle: "Vehículo",
    total: "Total",
    checkout: "Ir al checkout",
    close: "Cerrar",
    quoteSaved: "Cotización generada. Completa tu reservación abajo.",
  },
};

export const roundTripMultiplier = 1.85;
